"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMarketDescInfo = exports.mergeCloudMarketDescInfo = exports.checkMarketRecommendPionex = exports.checkMarketSupportStopLoss = exports.checkMarketSupportFutureTrade = exports.checkMarketSupportSpotTrade = exports.checkMarketSupportV2Api = exports.checkSupportLocalLogic = exports.checkMarketSupportSwap = exports.getBotSupportMarketList = exports.getSupportAIShocksMarketList = exports.checkMarketSupportOrderType = exports.checkPortfolioUseCloud = exports.checkFeeRateAutoCalc = exports.checkMarketSupportBUOrderBook = exports.checkMarketAccessWithBUCloud = exports.getSupportedTradeMarketInfoList = exports.getSupportedMarketListWithOrderTypes = exports.getSupportedMarketList = exports.isBotTradeSupported = exports.getMarkeNameIfSupport = exports.getSupportExchangeList = exports.isTradeSupported = void 0;
/**
 * 判断交易所是否支持交易
 * @param {string} market
 * @returns {boolean}
 */
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const OrderSupportDesc_1 = require("./OrderSupportDesc");
function isTradeSupported(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase === ExchangeID_1.ExchangeID.PIONEXV2 || marketLowerCase === ExchangeID_1.ExchangeID.PIONEX) {
        return true;
    }
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        let supportTypeList = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["support"];
        if (supportTypeList.length > 0) {
            return true;
        }
    }
    return false;
}
exports.isTradeSupported = isTradeSupported;
/**
 * 获取当前支持交易的交易所列表
 * @returns {Array<string>}
 */
function getSupportExchangeList() {
    let supportList = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key].support.length > 0) {
            supportList.push(key);
        }
    }
    return supportList;
}
exports.getSupportExchangeList = getSupportExchangeList;
/**
 * 获取交易所名称，统一调用方便配置
 * @param {string} market
 * @returns {string}
 */
function getMarkeNameIfSupport(market) {
    let param = market.trim().toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === param) {
            return key;
        }
    }
    return market;
}
exports.getMarkeNameIfSupport = getMarkeNameIfSupport;
function isBotTradeSupported(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase === ExchangeID_1.ExchangeID.PIONEXV2 || marketLowerCase === ExchangeID_1.ExchangeID.PIONEX) {
        return true;
    }
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        let supportTypeList = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["support"];
        if (supportTypeList && supportTypeList.length > 0) {
            if (supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.stopLimit) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.grid) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridClassic) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridPro) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridV3) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.ig) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridLoan) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridShort) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridLeverage) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridLeverageShort) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.ExchangeOrderType.gridFuture) >= 0) {
                return true;
            }
        }
    }
    return false;
}
exports.isBotTradeSupported = isBotTradeSupported;
function getSupportedMarketList(orderType) {
    let result = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        let support = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["support"];
        if (support.indexOf(orderType) >= 0) {
            result.push(key);
        }
    }
    if (!result.some(item => item === ExchangeID_1.ExchangeID.PIONEXV2)) {
        result.push(ExchangeID_1.ExchangeID.PIONEXV2);
    }
    return result;
}
exports.getSupportedMarketList = getSupportedMarketList;
function getSupportedMarketListWithOrderTypes(orderTypes) {
    let result = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        let support = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["support"];
        orderTypes.forEach(orderType => {
            if (support.indexOf(orderType) >= 0) {
                result.push(key);
            }
        });
    }
    if (!result.some(item => item === ExchangeID_1.ExchangeID.PIONEXV2)) {
        result.push(ExchangeID_1.ExchangeID.PIONEXV2);
    }
    return result;
}
exports.getSupportedMarketListWithOrderTypes = getSupportedMarketListWithOrderTypes;
function getSupportedTradeMarketInfoList() {
    let result = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        result.push({
            market: key,
            support: OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["support"],
        });
    }
    return result;
}
exports.getSupportedTradeMarketInfoList = getSupportedTradeMarketInfoList;
function checkMarketAccessWithBUCloud(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase === ExchangeID_1.ExchangeID.PIONEXV2 || marketLowerCase === ExchangeID_1.ExchangeID.PIONEX) {
        return true;
    }
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["useCloud"];
    }
    return false;
}
exports.checkMarketAccessWithBUCloud = checkMarketAccessWithBUCloud;
function checkMarketSupportBUOrderBook(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["webSocket"]["supportOrderBook"];
    }
    return false;
}
exports.checkMarketSupportBUOrderBook = checkMarketSupportBUOrderBook;
/**
 * check 是否支持费率的自动计算（不允许修改费率）
 * @param market
 */
function checkFeeRateAutoCalc(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["feeRate"]["autoCalc"];
    }
    return false;
}
exports.checkFeeRateAutoCalc = checkFeeRateAutoCalc;
/**
 * 判断持仓是佛偶支持云端
 * @param market
 */
function checkPortfolioUseCloud(market) {
    let marketLowerCase = market.toLowerCase();
    if (marketLowerCase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[marketLowerCase]["portfolio"]["useCloud"];
    }
    return false;
}
exports.checkPortfolioUseCloud = checkPortfolioUseCloud;
/**
 * 判断交易所是否支持某种订单
 * @param market
 * @param orderType
 */
function checkMarketSupportOrderType(market, orderType) {
    let marketLowerCase = market.toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === marketLowerCase) {
            let supportTypeList = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["support"];
            return supportTypeList.indexOf(orderType) >= 0;
        }
    }
    return false;
}
exports.checkMarketSupportOrderType = checkMarketSupportOrderType;
/**
 * 获取支持震荡指数的交易所
 */
function getSupportAIShocksMarketList() {
    let result = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if ("aiShocks" in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key] && OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["aiShocks"]) {
            result.push(key);
        }
    }
    return result;
}
exports.getSupportAIShocksMarketList = getSupportAIShocksMarketList;
function getBotSupportMarketList() {
    let result = [];
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        let supportTypeList = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["support"];
        if (supportTypeList && supportTypeList.length > 0) {
            if (supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.STOP_LIMIT) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_CLASSIC) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_PRO) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.IG) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_LOAN) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_SHORT) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_LEVERAGE) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.GRID_LEVERAGE_SHORT) >= 0
                || supportTypeList.indexOf(TradeTypeDef_1.OrderTypeDesc.TRAILING_STOP_LIMIT) >= 0) {
                result.push(key);
            }
        }
    }
    return result;
}
exports.getBotSupportMarketList = getBotSupportMarketList;
/**
 * check交易所是否支持期货交易
 * @param market
 */
function checkMarketSupportSwap(market) {
    let marketLowerCase = market.toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === marketLowerCase) {
            let futureTag = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["futureTag"];
            return futureTag !== undefined && futureTag !== "";
        }
    }
    return false;
}
exports.checkMarketSupportSwap = checkMarketSupportSwap;
function checkSupportLocalLogic(market) {
    let marketLowerCase = market.toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === marketLowerCase) {
            return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["localLogic"];
        }
    }
    return false;
}
exports.checkSupportLocalLogic = checkSupportLocalLogic;
/**
 * 是否支持V2接口
 * @param market
 */
function checkMarketSupportV2Api(market) {
    var _a;
    let marketLowerCase = market.toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === marketLowerCase) {
            return (_a = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["isV2"]) !== null && _a !== void 0 ? _a : false;
        }
    }
    return false;
}
exports.checkMarketSupportV2Api = checkMarketSupportV2Api;
/**
 * 是否支持现货手动交易
 * @param market
 */
function checkMarketSupportSpotTrade(market) {
    return checkMarketSupportOrderType(market, TradeTypeDef_1.ExchangeOrderType.limit)
        || checkMarketSupportOrderType(market, TradeTypeDef_1.ExchangeOrderType.market);
}
exports.checkMarketSupportSpotTrade = checkMarketSupportSpotTrade;
/**
 * 是否支持合约交易
 * @param market
 */
function checkMarketSupportFutureTrade(market) {
    return checkMarketSupportOrderType(market, TradeTypeDef_1.ExchangeOrderType.gridFuture);
}
exports.checkMarketSupportFutureTrade = checkMarketSupportFutureTrade;
/**
 * 判断某个交易所是否支持网格止损价设置
 * @param market
 */
function checkMarketSupportStopLoss(market) {
    let marketLowerCase = market.toLowerCase();
    for (let key in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        if (key === marketLowerCase) {
            return OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key]["supportStopLoss"];
        }
    }
    return false;
}
exports.checkMarketSupportStopLoss = checkMarketSupportStopLoss;
function checkMarketRecommendPionex(market) {
    return false;
}
exports.checkMarketRecommendPionex = checkMarketRecommendPionex;
function mergeCloudMarketDescInfo(cloudDescInfo) {
    for (let key in cloudDescInfo) {
        let cloudExchangeInfo = cloudDescInfo[key];
        let tradeExchangeInfo = OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[key];
        if ("webSocket" in cloudExchangeInfo) {
            tradeExchangeInfo["webSocket"] = cloudExchangeInfo["webSocket"];
        }
        if ("support" in cloudExchangeInfo) {
            tradeExchangeInfo["support"] = cloudExchangeInfo["support"];
        }
        if ("useCloud" in cloudExchangeInfo) {
            tradeExchangeInfo["useCloud"] = cloudExchangeInfo["useCloud"];
        }
        if ("feeRate" in cloudExchangeInfo) {
            tradeExchangeInfo["feeRate"] = cloudExchangeInfo["feeRate"];
        }
        if ("portfolio" in cloudExchangeInfo) {
            tradeExchangeInfo["portfolio"] = cloudExchangeInfo["portfolio"];
        }
        if ("importCheckTradePermission" in cloudExchangeInfo) {
            tradeExchangeInfo["importCheckTradePermission"] = cloudExchangeInfo["importCheckTradePermission"];
        }
        if ("futureTag" in cloudExchangeInfo) {
            tradeExchangeInfo["futureTag"] = cloudExchangeInfo["futureTag"];
        }
        if ("supportStopLoss" in cloudExchangeInfo) {
            tradeExchangeInfo["supportStopLoss"] = cloudExchangeInfo["supportStopLoss"];
        }
    }
}
exports.mergeCloudMarketDescInfo = mergeCloudMarketDescInfo;
function addMarketDescInfo(key, data) {
    let keyLowercase = key.toLowerCase();
    if (keyLowercase in OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC) {
        return;
    }
    OrderSupportDesc_1.MARKET_ORDER_SUPPORT_DESC[keyLowercase] = data;
}
exports.addMarketDescInfo = addMarketDescInfo;
